import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';

import CreatorCard from '../commonElements/creatorCard';
import CreatorTitle from '../commonElements/creatorTitle';
import { LomavisPlatformIcon } from '../../../../lomavisSharedUi/atoms/icons/LomavisPlatformIcon/LomavisPlatformIcon';
import { ALL, GENERIC } from '../../../../config/constants';

const PublishedOn: React.FC = () => {
  const { postData, has_been_published, lomavisCreatorConfig } = useSelector(
    (state: any) => state.lomavisCreator
  );
  const { t } = useTranslate();

  // A reused post is a new post; the links of the original don't belong to it.
  if (!has_been_published || lomavisCreatorConfig?.importing_post) return null;

  const platformUrls = Object.keys(postData).filter(
    (platform) =>
      platform !== GENERIC &&
      platform !== ALL &&
      postData?.[platform]?.platform_url
  );

  if (platformUrls.length === 0) return null;

  return (
    <CreatorCard>
      <CreatorTitle title="published_on" tooltipPosition="right" />
      <div className="d-flex flex-column gap-3">
        {platformUrls.map((platform) => (
          <PublishedOnRow
            key={platform}
            platform={platform}
            url={postData[platform].platform_url}
            t={t}
          />
        ))}
      </div>
    </CreatorCard>
  );
};

const PublishedOnRow: React.FC<{
  platform: string;
  url: string;
  t: (key: string) => string;
}> = ({ platform, url, t }) => {
  return (
    <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
      <div
        className="pe-3 flex-shrink-0"
        style={{ width: 20, lineHeight: 1 }}
      >
        <LomavisPlatformIcon platform={platform} />
      </div>
      <div className="flex-grow-1 text-end" style={{ minWidth: 0 }}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-light"
        >
          <i
            className="fas fa-arrow-up-right-from-square me-1"
            aria-hidden="true"
          ></i>
          {t('lomavisCreator.publishedOn.open')}
        </a>
      </div>
    </div>
  );
};

export default PublishedOn;
